import { Link as RouterLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { tools } from '../data/tools';

function Home() {
  return (
    <Box sx={{ pb: 4 }}>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: 'background.paper',
          color: 'text.primary',
          borderBottom: '1px solid',
          borderColor: 'divider',
          pt: 'env(safe-area-inset-top)',
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 56, sm: 64 } }}>
          <Box>
            <Typography variant="h6" component="h1">
              DT Converter
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Compressed air calculators
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ pt: 2, px: { xs: 2, sm: 3 } }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Choose a tool. Each calculator opens on its own screen so it stays usable on a phone.
        </Typography>
        <Grid container spacing={2}>
          {tools.map((tool) => {
            const Icon = tool.icon;
            return (
              <Grid item xs={12} sm={6} key={tool.path}>
                <Card>
                  <CardActionArea
                    component={RouterLink}
                    to={tool.path}
                    sx={{
                      p: 2,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 2,
                      minHeight: 112,
                    }}
                  >
                    <Box
                      sx={{
                        p: 1.25,
                        borderRadius: 2,
                        bgcolor: 'primary.main',
                        color: 'primary.contrastText',
                        display: 'flex',
                      }}
                    >
                      <Icon />
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="h2" sx={{ fontSize: '1.1rem', mb: 0.5 }}>
                        {tool.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {tool.description}
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}

export default Home;
